<template>
  <div>
    <div class="condition-section">
       <div class="con-row">
          <div
            :class="[
              'item',
              { active: index === statusSelect },
            ]"
            v-for="(item,index) in statusList"
            :key="index"
            @click="statusSelectChange(index)"
          >
            {{ item.name }}
          </div>
       </div>
       <div class="cond-row">
          <div class="item" style="margin-right: 10px">
            <div class="item-name">类型：</div>
            <Select
              class="height45 cart-bg-color-3a3c46 u-info"
              v-model="mailTypeSelect"
              style="width: 180px"
              clearable
            >
              <Option
                v-for="(item, index) in mailSiteTypeList"
                :value="item.value"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
          <div class="item" style="margin-right: 10px">
            <Input
              class="height45 bg-color-242631"
              v-model="keyword"
              placeholder="请输入搜索的关键词"
              style="width: 300px"
              clearable
            />
          </div>
         
          <div class="item">
            <Button
              class="btn-height45 bg-color-C4332E ivu-btn ivu-btn-primary"
              type="primary"
              style="margin-right: 10px"
              @click="pageChange(1)"
              >搜索</Button
            >
            <Button class="btn-height45 bg-color-51525B" @click="reset">重置</Button>
            <Button
              v-if='isRead === 0'
              class="btn-height45 bg-color-C4332E ivu-btn ivu-btn-primary"
              type="primary"
              style="margin-left: 10px"
              @click="setAsRead"
              >设为已读</Button
            >
            <Button
              v-if='isRead === 0'
              class="btn-height45 bg-color-C4332E ivu-btn ivu-btn-primary"
              type="primary"
              style="margin-left: 10px"
              @click="allSetAaRead"
              >全部设为已读</Button
            >
            <Button
              class="btn-height45 bg-color-C4332E ivu-btn ivu-btn-primary"
              type="primary"
              style="margin-left: 10px"
              @click="delectEvent"
              >删除</Button
            >
          </div>
        </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
       <Table
            class="bg-color-242631 td-color-303240"
            :loading="loading"
            ref="pushDomianTable"
            :columns="columns"
            :data="list"
            
            @on-select="onSelectEvent"
            @on-select-cancel="onSelectCancelEvent"
            @on-select-all="onSelectAllEvent"
            @on-select-all-cancel="onSelectAllCancelEvent"
            stripe
        ></Table>
       <div class="page-tool">
          <Page
              :total="total"
              :current="page"
              :page-size="pageSize"
              :page-size-opts="pageSizeOpts"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              show-elevator
              show-sizer
              show-total
          />
        </div>
    </div>
  </div>
</template>

<script>
import { pullAllWith, isEqual } from "lodash";
import { mailSiteList, mailSiteType, mailSiteRead,mialSiteDel } from "api/user.js";
import { mapActions } from "vuex";

export default {
  name: "mail",
  data() {
    return {
      loading:false,
      tablist: [
        {
          name: "站内信",
          to: "/user/mail",
        },
      ],
      isRead:0,
      statusList: [
        {
          name: "未读短信",
          value: 0,
        },
        {
          name: "已读短信",
          value: 1,
        }
      ],
      mailSiteTypeList: [],

      // 表单数据
      statusSelect: 0,
      keyword: "",
      mailTypeSelect: null,

      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          width: 100,
          title: "状态",
          key: "readFlag",
          align: "center",
          render: (h, params) => {
            let title = params.row.readFlag === 0 ? '未读' :'已读' ;
            return h("span", title);
          },
        },
        {
          width: 150,
          title: "类型",
          key: "target",
          align: "center",
        },
        {
          minWidth: 200,
          title: "标题",
          key: "content",
          align: "left",
          render: (h, params) => {
            return h(
              "p",
              {
                style: {
                    padding:'10px 0',
                },
              },
              params.row.content
            );
          },
        },
        {
          width: 200,
          title: "时间",
          key: "createdTime",
          align: "left",
        }
      ],
      selectAll: false,
      // 保存选中的数据
      selectList: [],

      // 分页设置
      total: null,
      pageSizeOpts: [50, 100, 200],
      pageSize: 50,
      page: 1,
      list: [],
    };
  },
  created() {
    this.getMailSiteType();
    this.pageChange(1)
  },
  methods: {
    ...mapActions(["ACT_USER_INFO"]),
    // 获取站内信类型
    async getMailSiteType() {
      let {code,data} = await mailSiteType();
      if(code === 200){
        this.mailSiteTypeList = data
      }
    },
    // 交易类型改变
    statusSelectChange(index) {
      this.statusSelect = index;
      this.isRead=this.statusList[this.statusSelect].value
      this.pageChange(1);
    },

    // 切换pageSize
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageChange(1);
    },
    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getMailSiteList();
    },
    // 重置
    reset() {
      this.keyword = "";
      this.mailTypeSelect = null;
      this.page = 1;
      this.getMailSiteList();
    },
    // 获取列表
    async getMailSiteList() {
      this.loading = true;
      let params = {
        kw: this.keyword,
        siteType: this.mailTypeSelect,
        isRead:this.statusList[this.statusSelect].value,
        limit: this.pageSize,
        page: this.page,
      };
      let res = await mailSiteList(params);
      if (res.code == 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    },

    // 设为已读
    async setAsRead(){
      if(this.selectList.length <= 0){
        this.$Message.warning("请选择数据");
        return;
      }
      let msgIds = this.selectList.map(item => item.id)
      let params = {
        msgIds:msgIds,
        isReadAll:0
      }
      const {code} = await mailSiteRead(params);
      if(code === 200){
        this.$Message.success("设置成功");
        this.page = 1;
        this.getMailSiteList();
        this.ACT_USER_INFO();
      }
    },
    // 全部设为已读
    allSetAaRead(){
      this.$Modal.confirm({
        title: "全部设为已读",
        content: "<p>确定全部设为已读吗？</p>",
        onOk: async () => {
         this.$refs.pushDomianTable.selectAll(true);
         let msgIds = this.selectList.map(item => item.id)
          let params = {
            msgIds:msgIds,
            isReadAll:1
          }
          const {code} = await mailSiteRead(params);
          if(code === 200){
            this.$Message.success("设置成功");
            this.page = 1;
            this.getMailSiteList();
            this.ACT_USER_INFO();
          }
        },
      });
    },
    // 删除
    delectEvent(){
      if(this.selectList.length <= 0){
        this.$Message.warning("请选择数据");
        return;
      }
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除吗？</p>",
        onOk: async () => {
          let msgIds = this.selectList.map(item => item.id)
          const res = await mialSiteDel({msgIds});
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("删除成功！");
            this.page = 1;
            this.getMailSiteList();
            this.ACT_USER_INFO();
          }
        },
      });
    },
    // checkbox全选的数据
    onSelectAllEvent(selection) {
       this.selectList = selection;
    },
    // checkbox取消全选的数据
    onSelectAllCancelEvent() {
      this.selectList = [];
    },
    // checkbox单个选中数据
    onSelectEvent(selection, row) {
      this.selectList.push(row);  
    },
    // checkbox单个取消数据
    onSelectCancelEvent(selection, row) {
      this.selectList = pullAllWith(this.selectList, [row], isEqual);
    }
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .con-row{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item{
      margin-right:20px;
      cursor: pointer;
      font-size: 16px;
      &.active{
        color: #3992e9;
        font-weight: bold;
      }
    }
  }
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
    }
  }
}

.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
